import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { PositionProvider } from "../../../context/PositionContext";

export const Music = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddMusic = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditMusic = () => {
  return (
    
      
        <Edit />
      
    
  );
};

export const ViewMusic = () => {
  return (
    
      <Detail />
    
  );
};
